import { Loader2, type LucideIcon } from 'lucide-react';
import type { ReactElement } from 'react';
import { RAIL_ITEM_STYLES } from './rail-item-styles';

interface RailIconButtonProps {
  readonly icon: LucideIcon;
  /** 아이콘 아래 보이는 짧은 글자. */
  readonly label: string;
  /** 보이는 글자를 포함한 온전한 이름 — 없으면 label. */
  readonly accessibleName?: string;
  /** 막힌 이유 등 보조 설명 요소 id. */
  readonly describedBy?: string;
  readonly title?: string;
  readonly disabled?: boolean;
  /** 진행 중이면 아이콘 대신 돌아가는 표시를 보인다. */
  readonly busy?: boolean;
  readonly onClick: () => void;
}

/** 스테이지 도구 칸의 버튼 — 흰 사각 칸에 아이콘과 작은 글자. 넓은 화면은 세로 줄, 좁은 화면은 가로 줄에 선다. */
export const RailIconButton = ({
  icon: Icon,
  label,
  accessibleName,
  describedBy,
  title,
  disabled = false,
  busy = false,
  onClick,
}: RailIconButtonProps): ReactElement => (
  <button
    type="button"
    aria-label={accessibleName}
    aria-describedby={describedBy}
    title={title ?? accessibleName ?? label}
    disabled={disabled}
    className={RAIL_ITEM_STYLES.item}
    onClick={onClick}
  >
    {busy ? (
      <Loader2 aria-hidden className={`${RAIL_ITEM_STYLES.icon} animate-spin`} strokeWidth={1.5} />
    ) : (
      <Icon aria-hidden className={RAIL_ITEM_STYLES.icon} strokeWidth={1.5} />
    )}
    <span aria-live={busy ? 'polite' : undefined} className="whitespace-nowrap">
      {label}
    </span>
  </button>
);
